import BaseRepository from '@/core/standard/BaseRepository';
import { axiosInstance } from '@/setup/axios/AxiosConfig';
import { GenericMethod, UrlParams } from '@/core/Types/IRepository';

class OfferService extends BaseRepository {
    public collection = 'promotions';
    public version = 'v1';

    public validateByCode(params: GenericMethod): Promise<any> {
        return this.request({ query:{...params}, url: 'is_enabled', method: 'POST' });
    }

    public checkCodeUniqueness(params: GenericMethod): Promise<any> {
        return this.request({ query: {...params}, url:"check_code", method:"GET"});
    }
}

export default new OfferService(axiosInstance);
